import BasicMount from 'pages/CatalogPage/DH/Tires/BasicMount/BasicMount';

export default BasicMount;
